module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-N.d9eb65a3.png";